'use strict';

import $ from 'jquery';
import PerfectScrollbar from 'perfect-scrollbar';

const slick = require('slick-carousel-browserify');

const videojs = require('video.js');
const youtube = require('videojs-youtube');

export default class VideosCarousel {
  constructor() {

    // Contamos el número total de slides y configuramos la inicial
    const slideCount = $('*[data-js="videos-carousel-nav"] > article').length;
    let initialSlide = 0;
    if ( slideCount > 1 ) {
      if ( slideCount % 2 === 0 ) {
        initialSlide = slideCount / 2 - 1;
      } else {
        initialSlide = Math.floor(slideCount/2) + 1;
      }
    }

    this.videoCarousel = $('*[data-js="videos-carousel"]').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: initialSlide,
      adaptiveHeight: false,
      arrows: false,
      fade: true,
      asNavFor: '.videos-carousel__nav',
    });

    $('*[data-js="videos-carousel-nav"]').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: initialSlide,
      asNavFor: '.videos-carousel',
      dots: false,
      arrows: false,
      centerMode: true,
      infinite: false,
      centerPadding: '0px',
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 100024,
          settings: 'unslick'
        },{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerPadding: '80px',
          }
        },{
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '80px',
          }
        }
      ]
    });

    $(window).resize( () => {
      this.DesktopVideosCarousel();
    });
    this.DesktopVideosCarousel();

    this.videoCarousel.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      this.SelectActiveSlideFromSideNav(nextSlide);
      this.clickBind();
      $('.video-js').each(function () {
        videojs(this.id).ready(function () {
          var myPlayer = this;
          myPlayer.pause();
        });
      });
    });

    if ( $('*[data-js="videos-carousel-video"]').length > 0 ) {
      this.clickBind();
    }
  }

  SelectActiveSlideFromSideNav(slide) {

    const $videosCarousel = $('*[data-js="videos-carousel-slide"]');

    $videosCarousel.each( (index, ele) => {
      if ( $(ele).data('slide') !== slide ){
        $(ele).removeClass('active');
      }else{
        $(ele).addClass('active');
      }
    });
  }

  DesktopVideosCarousel() {
    const $videosCarousel = $('*[data-js="videos-carousel-slide"]');
    if ( $videosCarousel.length == 0 ) return; // Break si no hay carousel

    if ( $(document).width() >= 1024 ) {
      const container = document.querySelector('.videos-carousel__nav');
      const ps = new PerfectScrollbar(container,{
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20,
        suppressScrollX: true
      });
      $videosCarousel.on('click', (event) => {
        this.videoCarousel.slick('slickGoTo', event.delegateTarget.attributes['data-slide'].value);
      });
    }else{
      $('*[data-js="videos-carousel-slide"]').unbind('click');
    }
  }

  clickBind() {
    $('*[data-js="videos-carousel-video"]').on('click', (event) => {
      const $delegateTarget = $(event.delegateTarget);
      const ID = $delegateTarget.find('video').get(0).id;
      const player = videojs(ID, {
        'techOrder': ['html5','youtube']
      });
      player.src({
        'type': 'video/youtube',
        'src': $delegateTarget.find('video').data('youtube')
      });

      $delegateTarget.addClass('playing');

      $delegateTarget.find('.video-js').css('display','block');
      $delegateTarget.find('video').css('display','block');

      this.clickUnbind();
      player.play();

      player.on('ended', () => {
        this.clickBind();
        $delegateTarget.removeClass('playing');
      });
    });
  }

  clickUnbind() {
    $('*[data-js="videos-carousel-video"]').unbind('click');
  }
}
